import Div from "@jumbo/shared/Div/Div";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import "./PreviewFormSelected.css";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {applicantFormCodes, assigneeTenants, inventorFormCodes, tenant} from "../../../constants";


const PreviewModifyFormsSelected = ({upperSectionProps, setUpperSectionProps, lowerSectionProps, setSelectedForm, checkedForms, setCheckedForms, upperSectionItems, isEditable, formList, setFormList}) => {
    const navigate = useNavigate();

    const [upperSelectedItems, setUpperSelectedItems] = useState(upperSectionProps.selectedItem);
    const [lowerSelectedItems, setLowerSelectedItems] = useState(lowerSectionProps?.selectedItem);

    useEffect(() => {
        setUpperSectionProps(upperSectionItems);
    }, []);

    // Update component when selectedForm changes
    useEffect(() => {
        setUpperSelectedItems(upperSectionProps.selectedItem);
    }, [upperSectionProps.selectedItem]);

    useEffect(() => {
        if (upperSectionProps?.selectedItems) {
            if (upperSectionProps.selectedItems?.length === 0) {
                navigate("/docgen/drafts");
            } else {
                setUpperSectionProps((prevState) => ({...prevState, selectedItem: upperSectionProps?.selectedItems[0].id}));
                setSelectedForm(upperSectionProps?.selectedItems[0]?.id);
                setUpperSelectedItems(upperSectionProps?.selectedItems[0]?.id);
            }
        }
    }, [upperSectionProps?.selectedItems]);

    const handleRemove = async (generatedFormId) => {
        setUpperSectionProps((prevState) => {
            const newState = {...prevState};
            const newFormList = newState.selectedItems.filter(item => item.id !== generatedFormId);
            return (
                {...prevState, selectedItems: newFormList}
            );
        });
        const updatedFormList = formList.filter((form) => form.id !== generatedFormId);
        setFormList(updatedFormList);
        setCheckedForms({});
    };

    const displayModifiedFormName = (item) => {
        if (inventorFormCodes.includes(item?.generated_form?.form_code)) {
            const inventorList = item?.generated_form_matter?.matter_parties?.filter(matter => matter?.party_type === "Inventor")?.map(contact => contact?.party?.name);
            const selectedInventor = inventorList?.find(inventor => item.contactName === inventor);
            if (selectedInventor) {
                return `${item?.generated_form_matter?.host_file_number}-${item?.generated_form?.form_code}_${selectedInventor}`;
            }
        }
        if (applicantFormCodes.includes(item?.generated_form?.form_code)) {
            const applicantList = item?.generated_form_matter?.matter_parties?.filter(matter => matter?.party_type === (assigneeTenants.has(tenant) ? "Assignee" : "Applicant"))?.map(contact => contact?.party?.name);
            const selectedApplicant = applicantList?.find(applicant => item.contactName === applicant);
            if (selectedApplicant) {
                return `${item?.generated_form_matter?.host_file_number}-${item?.generated_form?.form_code}_${selectedApplicant}`;
            }
        }
        return `${item?.generated_form_matter?.host_file_number}-${item?.generated_form?.form_code}`;
    };

    return (
        <Div className="pfs-wrapper">
            <Div
                sx={{
                    maxHeight: lowerSectionProps ? "50% !important" : "100% !important",
                    height: "auto"
                }}
                className="pfs-wrapper-1 pfs-wrapper-item"
            >
                <div className="heading-area">
                    <Typography
                        component={"h4"}
                        sx={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            padding: "10px"
                        }}
                    >
                        {upperSectionProps.title}
                    </Typography>
                </div>
                <div className="pfs-area customize-scrollbar">
                    {
                        // selectedItems CONTAINS THE LIST OF THE SELECTED ROWS
                        upperSectionProps.selectedItems?.map((item, index) => {
                            return (
                                <Box key={item.id} sx={{display: "flex", alignItems: "center", justifyContent: "left"}}>
                                    {isEditable !== false && <Checkbox
                                        size="small"
                                        checked={checkedForms[item.id] || false}
                                        onChange={() => {
                                            setCheckedForms((prevState) => ({...prevState, [item.id]: !prevState[item.id]}));
                                        }}
                                    />}
                                    <Box
                                        sx={{p: 1, cursor: "pointer"}}
                                        className={`customize-chip text-center ${
                                            // To set the color to green by passing a class
                                            upperSectionProps?.setColor
                                                ? upperSectionProps?.setColor
                                                : ""
                                        } ${upperSelectedItems === item.id ? "selected" : ""}`}
                                        onClick={() => {
                                            setUpperSelectedItems(upperSectionProps.selectedItems[index]?.id);
                                            setSelectedForm(upperSectionProps.selectedItems[index]?.id);
                                            setUpperSectionProps((prevState) => ({...prevState, selectedItem: upperSectionProps.selectedItems[index]?.id}));
                                        }}>
                                        {displayModifiedFormName(item)}

                                    </Box>
                                    <Box flexGrow={1}/>
                                    <span
                                        style={{marginLeft: "2%", cursor: "pointer"}}
                                        onClick={e => {
                                            e.stopPropagation();
                                            handleRemove(item.id);
                                        }}
                                    >
                                        X
                                    </span>
                                </Box>
                            );
                        })
                    }
                </div>
            </Div>
            {lowerSectionProps && (
                <Div
                    sx={{
                        maxHeight: "50% !important",
                        height: "auto"
                    }}
                    className="pfs-wrapper-2 pfs-wrapper-item"
                >
                    <div className="heading-area">
                        <Typography
                            component={"h4"}
                            sx={{
                                fontSize: "16px",
                                fontWeight: "500",
                                textAlign: "center",
                                padding: "10px"
                            }}
                        >
                            {lowerSectionProps.title}
                        </Typography>
                    </div>
                    <div className="pfs-area customize-scrollbar">
                        {lowerSectionProps?.selectedItems?.map((item, index) => {
                            return (
                                <Button
                                    key={item.id}
                                    className={`customize-chip orange-chip text-center ${
                                        lowerSelectedItems === item.id ? "selected" : ""
                                    }`}
                                    label={item.title}
                                    onClick={() => setLowerSelectedItems(upperSectionProps.selectedItems[index].id)}
                                >
                                    {item.title}
                                </Button>
                            );
                        })}
                    </div>
                </Div>
            )}
        </Div>
    );
};


export default PreviewModifyFormsSelected;